export const SETTINGS_CLEAR = 'SETTINGS_CLEAR';
export const SETTINGS_TOGGLE_DROPDOWN = 'SETTINGS_TOGGLE_DROPDOWN';
export const SETTINGS_SELECT_LANG = 'SETTINGS_SELECT_LANG';
export const SETTINGS_HIDE_POP_UP = 'SETTINGS_HIDE_POP_UP';
export const SETTINGS_SHOW_POP_UP = 'SETTINGS_SHOW_POP_UP';
export const SETTINGS_SET_LOCALIZATION_MAINTENANCE = 'SETTINGS_SET_LOCALIZATION_MAINTENANCE';
